export default __webpack_public_path__ + "static/media/Boomstore1.1d4907d8.png";